import { ModalProps } from '../../../services/modals.service';
import { KeyedMutator } from 'swr';
import { User, UserSelect } from '../../common/user-select';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { required } from '../../../utils/validations';
import { InputWrapper } from '../../common/input-wrapper';
import { api } from '../../../services/api';
import { AlertService } from '../../../services/alert.service';
import { CleanUser } from '../../../export-types/cleaned-types';
import { useModalClose } from '../../../utils/useModalClose';
import { trpc } from '../../../api/trpc';

interface LinkUserModalProps extends ModalProps {
  user?: CleanUser;
  mutate?: KeyedMutator<any>;
  orderIds?: string[];
  setSelectedOrders?: (value: Set<string>) => void;
}

export const LinkUserModal = ({
  user,
  close,
  mutate,
  orderIds,
  setSelectedOrders,
}: LinkUserModalProps) => {
  const { control, handleSubmit } = useForm<{
    user: User;
  }>();

  const onSubmit = handleSubmit(async ({ user: manager }) => {
    try {
      if (user) {
        await api.post(`/user/${user.id}/link`, {
          userId: manager.id,
        });
      } else if (orderIds?.length) {
        await trpc.user.userBulkLink.link.mutate({
          ids: orderIds,
          managerId: manager.id,
        });
      }

      AlertService.success();
      setSelectedOrders?.(new Set());
      mutate?.();
    } catch (error: any) {
      AlertService.error(error?.message);
    } finally {
      close();
    }
  });
  const modalRef = useModalClose(close);
  const hasSelection = !!user || (orderIds && orderIds.length > 0);

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button type="button" className="btn-close" onClick={() => close()} />
        </div>

        {hasSelection ? (
          <div className="modal-body pt-2 p-4">
            <div className="text-center mb-4 mx-auto">
              <h3>
                {user
                  ? 'Выберите менеджера для привязки к этому клиенту'
                  : 'Выберите менеджера для привязки к выбранным клиентам'}
              </h3>
            </div>
            <form onSubmit={onSubmit}>
              <Controller
                control={control}
                name="user"
                rules={{ ...required }}
                render={({ field, fieldState }) => (
                  <InputWrapper
                    className="mb-3"
                    title="Менеджер"
                    required
                    error={fieldState.error?.message}
                  >
                    <UserSelect
                      placeholder="Выберите менеджера"
                      {...field}
                      access={'salesManager'}
                      roles={['employee', 'admin']}
                    />
                  </InputWrapper>
                )}
              />
              <button type="submit" className="btn btn-success w-100 mb-3">
                Привязать
              </button>
              <button
                type="button"
                className="btn btn-light w-100"
                onClick={() => close()}
              >
                Отменить
              </button>
            </form>
          </div>
        ) : (
          <div className="modal-body text-center">
            <i className="bi bi-exclamation-triangle-fill mb-3 fs-1 text-danger"></i>
            <h5 className="fw-bold">Вы не выбрали ни одного клиента</h5>
            <p className="mb-4 text-danger">
              Пожалуйста, выберите хотя бы одного клиента в списке, чтобы
              привязать менеджера.
            </p>
            <button
              type="button"
              className="btn btn-light mt-4 w-100"
              onClick={() => close()}
            >
              Закрыть
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
